<template>
  <!-- 排序组件 -->
  <div class="sort-bg">
    <div v-show="!openPreviewStatus">
      <div class="sort-box" v-loading="bottonLoading">
        <div class="sort-header">
          <div class="sort-title">发布到公众号</div>
          <img alt="" @click="closeDialog" class="sort-close" :src="g_imgSrc.delete" />
        </div>
        <div class="sort-body">
          <div class="sort-left">
            <div class="sort-left-content">
              <template v-if="articleList.length === 1">
                <div class="top_article">
                  <!-- <el-image :src="articleList[0].cover_url"></el-image> -->
                  <el-image
                    :src="articleList[0].cover_list_url || articleList[0].cover_url"
                  ></el-image>
                </div>
                <div class="article_item no_hover">
                  <div class="item_title">{{ articleList[0].title }}</div>
                </div>
              </template>
              <div
                v-else
                v-for="(item, index) in articleList"
                :key="index"
                @click="activeArticle(index)"
              >
                <div class="top_article" v-if="index === 0">
                  <!-- <el-image :src="item.cover_url"></el-image> -->
                  <el-image
                    :src="articleList[0].cover_list_url || articleList[0].cover_url"
                  ></el-image>
                  <div class="top_article_title">{{ item.title }}</div>
                </div>
                <div v-else class="article_item" :class="{ active: index === activeIndex }">
                  <div class="item_title">{{ item.title }}</div>
                  <el-image :src="item.cover_url" class="item_cover" fit="cover"></el-image>
                </div>
              </div>
            </div>
            <div class="left-control">
              <img alt="" @click="goUp" :src="g_imgSrc.up" class="control-item" />
              <img alt="" @click="goDown" :src="g_imgSrc.down" class="control-item" />
              <img alt="" @click="deleteArticle" :src="g_imgSrc.ashcan" class="control-item" />
            </div>
          </div>
          <div class="sort-right">
            <el-tabs v-model="selectedTab" @tab-click="handleTabClick" type="card">
              <el-tab-pane label="按策略发送" name="0">
                <div class="right-title">群发对象</div>
                <el-form
                  :model="form"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="92px"
                  class="right-form"
                >
                  <el-form-item label="策略:" prop="strategy_id">
                    <el-select
                      v-model="form.strategy_id"
                      filterable
                      remote
                      :clearable="true"
                      placeholder="请选择/或输入关键词"
                      :remote-method="remoteSearchStrategy"
                      ref="strategySelect"
                      @focus="selectFocus('strategySelect', 'strategyList')"
                      @change="strategyChange"
                    >
                      <el-option
                        v-for="(item, index) in strategyList"
                        :key="index"
                        :label="item.strategy_name"
                        :value="item.id"
                        :disabled="item.status == 2"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公众号:" prop="app_id">
                    <el-select
                      v-model="form.app_id"
                      :clearable="true"
                      @change="appListChange"
                      placeholder="请先选择策略"
                    >
                      <el-option
                        v-for="(item, index) in pubulcList"
                        :key="index"
                        :label="item.app_name"
                        :value="item.app_id"
                        :disabled="item.status === 2"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- {{ form.app_id + form.strategy_name }} -->
                  <div class="news" v-if="form.app_id && form.strategy_name">
                    <div style="height: 40px; font-size: 14px; line-height: 40px">
                      策略涉及:
                      {{ strategyUserCount ? strategyUserCount : '0' }} 人
                    </div>
                    <!-- <div class="send-number">
                      过去7天该策略发送了
                      {{ this.messageTimes ? this.messageTimes : '0' }} 次,发送给了
                      {{ this.strategySendUserCount ? this.strategySendUserCount : '0' }}
                      人次
                    </div> -->
                  </div>
                  <div class="right-middle-line" />
                  <el-form-item label="定时群发" class="release-el-form-item">
                    <el-switch
                      v-model="form.is_set_time"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      style="top: 0"
                    />
                  </el-form-item>
                  <div v-show="form.is_set_time" class="right-explanation">
                    您可选择5分钟后，在一周内定时群发，成功设置后不支持修改，不可取消。
                  </div>
                  <el-form-item
                    label="发送时间:"
                    v-show="form.is_set_time"
                    required
                    style="margin-left: 0"
                  >
                    <div class="date_picker_row">
                      <el-date-picker
                        v-model="form.date"
                        type="date"
                        placeholder="选择日期"
                        class="date_picker"
                        format="MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        @change="changeDatePicker"
                        :picker-options="pickerOptionsDay"
                      ></el-date-picker>
                      <el-time-picker
                        class="time_select"
                        v-model="form.startTime"
                        :picker-options="pickerOptionsMinute"
                        :default-value="defaultValue"
                        value-format="HH:mm:ss"
                        placeholder="选择当前时间的后5分钟"
                      ></el-time-picker>
                    </div>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="按名单发送" name="1">
                <div class="right-title">群发对象</div>
                <el-form
                  :model="form"
                  :rules="rules2"
                  ref="ruleForm2"
                  label-width="92px"
                  class="right-form"
                >
                  <el-form-item label="名单:" prop="strategy_id">
                    <el-select
                      v-model="form.RosterId"
                      filterable
                      remote
                      :clearable="true"
                      placeholder="请选择/或输入关键词"
                      :remote-method="remoteSearchRoster"
                      ref="rosterSelect"
                      @focus="selectFocus('rosterSelect', 'rosterList')"
                      @change="rosterFormChange"
                    >
                      <el-option
                        v-for="(item, index) in rosterList"
                        :key="index"
                        :label="item.RosterName"
                        :value="item.RosterId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公众号:" prop="app_id">
                    <el-select
                      v-model="form.app_id"
                      :clearable="true"
                      @change="rosterFormChange"
                      placeholder="请先选择名单"
                      :disabled="!form.RosterId"
                    >
                      <el-option
                        v-for="(item, index) in passAppList"
                        :key="index"
                        :label="item.app_name"
                        :value="item.app_id"
                        v-show="item.type === 2"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- {{ form.app_id + form.strategy_name }} -->
                  <div class="news" v-if="form.app_id && form.RosterId">
                    <div style="font-size: 14px">
                      计划发送 {{ rosterUserCount.Total }} 人， 实际发送
                      {{ rosterUserCount.Success }} 人， 无法发送 {{ rosterUserCount.Fail }} 人
                      <publishRosterDetail
                        :app-id="form.app_id"
                        :roster-id="form.RosterId"
                      ></publishRosterDetail>
                    </div>
                    <!-- <div class="send-number">
                      过去7天该策略发送了
                      {{ this.messageTimes ? this.messageTimes : '0' }} 次,发送给了
                      {{ this.strategySendUserCount ? this.strategySendUserCount : '0' }}
                      人次
                    </div> -->
                  </div>
                  <div class="right-middle-line" />
                  <el-form-item label="定时群发" class="release-el-form-item">
                    <el-switch
                      v-model="form.is_set_time"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      style="top: 0"
                    />
                  </el-form-item>
                  <div v-show="form.is_set_time" class="right-explanation">
                    您可选择5分钟后，在一周内定时群发，成功设置后不支持修改，不可取消。
                  </div>
                  <el-form-item
                    label="发送时间:"
                    v-show="form.is_set_time"
                    required
                    style="margin-left: 0"
                  >
                    <div class="date_picker_row">
                      <el-date-picker
                        v-model="form.date"
                        type="date"
                        placeholder="选择日期"
                        class="date_picker"
                        format="MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        @change="changeDatePicker"
                        :picker-options="pickerOptionsDay"
                      ></el-date-picker>
                      <el-time-picker
                        class="time_select"
                        v-model="form.startTime"
                        :picker-options="pickerOptionsMinute"
                        :default-value="defaultValue"
                        value-format="HH:mm:ss"
                        placeholder="选择当前时间的后5分钟"
                      ></el-time-picker>
                    </div>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="按指定人员发送" name="2">
                <div class="right-title">群发对象</div>
                <el-form
                  :model="form"
                  :rules="rules2"
                  ref="ruleForm3"
                  label-width="92px"
                  class="right-form"
                >
                  <el-form-item label="粉丝名单:" prop="strategy_id">
                    <el-select
                      v-model="form.fanRosterId"
                      filterable
                      remote
                      :clearable="true"
                      placeholder="请选择/或输入关键词"
                      :remote-method="remoteSearchFanRoster"
                      ref="fanRosterSelect"
                      @focus="selectFocus('fanRosterSelect', 'fanRosterList')"
                      @change="fanRosterFormChange"
                    >
                      <el-option
                        v-for="(item, index) in fanRosterList"
                        :key="index"
                        :label="item.RosterName"
                        :value="item.RosterId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公众号:" prop="app_id">
                    <el-select
                      v-model="form.app_id"
                      :clearable="true"
                      @change="fanRosterFormChange"
                      placeholder="请先选择名单"
                      :disabled="!form.fanRosterId"
                    >
                      <el-option
                        v-for="(item, index) in passAppList"
                        :key="index"
                        :label="item.app_name"
                        :value="item.app_id"
                        v-show="item.type === 2"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- {{ form.app_id + form.strategy_name }} -->
                  <div class="news" v-if="form.app_id && form.fanRosterId">
                    <div style="font-size: 14px">
                      计划发送 {{ fanRosterCount.Total }} 人
                      <publishRosterDetail
                        :app-id="form.app_id"
                        :roster-id="form.fanRosterId"
                        :roster-type="1"
                      ></publishRosterDetail>
                    </div>
                    <!-- <div class="send-number">
                      过去7天该策略发送了
                      {{ this.messageTimes ? this.messageTimes : '0' }} 次,发送给了
                      {{ this.strategySendUserCount ? this.strategySendUserCount : '0' }}
                      人次
                    </div> -->
                  </div>
                  <div class="right-middle-line" />
                  <el-form-item label="定时群发" class="release-el-form-item">
                    <el-switch
                      v-model="form.is_set_time"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      style="top: 0"
                    />
                  </el-form-item>
                  <div v-show="form.is_set_time" class="right-explanation">
                    您可选择5分钟后，在一周内定时群发，成功设置后不支持修改，不可取消。
                  </div>
                  <el-form-item
                    label="发送时间:"
                    v-show="form.is_set_time"
                    required
                    style="margin-left: 0"
                  >
                    <div class="date_picker_row">
                      <el-date-picker
                        v-model="form.date"
                        type="date"
                        placeholder="选择日期"
                        class="date_picker"
                        format="MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        @change="changeDatePicker"
                        :picker-options="pickerOptionsDay"
                      ></el-date-picker>
                      <el-time-picker
                        class="time_select"
                        v-model="form.startTime"
                        :picker-options="pickerOptionsMinute"
                        :default-value="defaultValue"
                        value-format="HH:mm:ss"
                        placeholder="选择当前时间的后5分钟"
                      ></el-time-picker>
                    </div>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <el-form label-width="92px">
              <el-form-item label="审批人">
                <el-select
                  v-model="form.verifyUser"
                  :placeholder="`${form.app_id ? '请选择' : '请先选择应用'}`"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="manager in managerList"
                    :key="manager.id"
                    :value="String(manager.id)"
                    :label="manager.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="sort-footer">
          <el-button class="sort-btn cancel" @click="openPreview">手机预览</el-button>
          <el-button
            type="primary"
            class="sort-btn sure"
            :disabled="!publishData"
            :loading="bottonLoading"
            @click="submitForm"
          >
            确定发布
          </el-button>
        </div>
      </div>
    </div>
    <preview
      v-if="openPreviewStatus"
      :app_id="form.app_id"
      :article-list="articleList"
      @closeDialog="closeDialog"
      @closePreview="closePreview"
      @preViewWechat="preViewWechat"
    />
  </div>
</template>

<script>
import preview from './preview';
import publishRosterDetail from './components/publishRosterDetail';
import {
  publishArticleWeChatPageApi,
  userCountByAppIdAndStrategyIdApi,
  CheckArticlePublish,
} from '@/api/releaseManagement.js';
import { getStrategyList, GetManagerInfoByAppOrAgentId } from '@/api/setUser';
import { formatTime } from '@/utils/time.js';
import { mapGetters } from 'vuex';
import { GetRosterList, GetSendUserNum } from '@/api/roster';
import { GetUserStatPages } from '@/api/dataCenter';
export default {
  name: 'SortBox',
  components: {
    preview,
    publishRosterDetail,
  },
  data() {
    return {
      openPreviewStatus: false, // 预览
      form: {
        app_id: '',
        strategy_id: '',
        RosterId: '',
        fanRosterId: '',
        is_set_time: false,
        date: '',
        startTime: '',
        strategy_name: '',
        verifyUser: '',
      },
      rules: {
        strategy_id: [{ required: true, message: '请选择策略', trigger: 'change' }],
        app_id: [{ required: true, message: '请选择公众号', trigger: 'blur' }],
      },
      rules2: {
        RosterId: [{ required: true, message: '请选择名单', trigger: 'change' }],
        app_id: [{ required: true, message: '请选择公众号', trigger: 'blur' }],
      },

      pickerOptionsDay: {
        disabledDate(time) {
          const tempTime = time.getTime();
          const nowTime = Date.now();
          return tempTime < nowTime - 86400000 || tempTime > nowTime + 604800000;
        },
      },
      pickerOptionsMinute: {
        selectableRange: '',
      },
      selectedApp: '',
      selectedStrategy: '',
      selectedRoster: '',
      selectedFanRoster: '',
      bottonLoading: false, // 确定发布的Loading
      strategyUserCount: '',
      messageTimes: '',
      strategySendUserCount: '',
      // 文章列表
      articleList: [],
      // 高亮的index
      activeIndex: null,
      pubulcList: [],
      strategyList: [],
      defaultValue: null,
      nowDay: formatTime(new Date(), 'yyyy-mm-dd'),
      hintVoteForbidShow: false,
      noPassList: [],
      previewFrom: {},
      passAppList: [],

      selectedTab: '0',
      rosterList: [],
      fanRosterList: [],
      rosterUserCount: {
        Total: 0,
        Success: 0,
        Fail: 0,
      },
      fanRosterCount: {
        Total: 0,
        Success: 0,
        Fail: 0,
      },
      managerList: [], // 管理员列表
      publishChecked: false,
    };
  },
  computed: {
    publishData() {
      if (
        ((this.form.strategy_id || this.form.strategy_id === 0) && this.form.app_id) ||
        (this.form.RosterId && this.form.app_id) ||
        (this.form.fanRosterId && this.form.app_id)
      ) {
        if (this.form.is_set_time) {
          return !!(this.form.date && this.form.startTime);
        }
        return true;
      }
      return false;
    },
    ...mapGetters('user', {
      enterpriseId: 'getEnterpriseId',
      userId: 'getUserId',
    }),
  },
  methods: {
    getManagerList() {
      this.form.verifyUser = '';
      GetManagerInfoByAppOrAgentId({
        AppId: this.form.app_id || '',
      })
        .then(({ ManagerInfos: list }) => {
          console.log(list);
          // 去掉登录者本人（如果有的话）
          for (const item of list) {
            if (item.id === this.userId) {
              list.splice(list.indexOf(item), 1);
              break;
            }
          }
          list.unshift({
            id: '',
            name: '无需审批',
          });
          this.managerList = list;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    setPassAppList(arr) {
      this.passAppList = arr.concat([]);
    },
    // 发布预览成功后的回调
    preViewWechat(form) {
      this.previewFrom = form;
    },
    appListChange(id) {
      const selectedAppObj = this.pubulcList.find((e) => {
        return e.app_id == id;
      });
      this.selectedApp = selectedAppObj.app_name;
      this.getManagerList();
      if (this.form.strategy_id === 0) {
        GetUserStatPages({
          appid: id,
          source: 1,
        }).then(({ cumulate_num: num }) => {
          this.strategyUserCount = num;
        });
      } else {
        const flag = this.pubulcList.find((e) => {
          return e.app_id == id;
        });
        if (flag) {
          this.strategyUserCount = flag.count;
        }
      }
    },
    handleTabClick(tab) {
      // console.log('tab', tab.name);
      if (tab.name === '0') {
        this.form.RosterId = '';
        this.form.fanRosterId = '';
      } else if (tab.name === '1') {
        this.form.strategy_id = '';
        this.form.fanRosterId = '';
      } else if (tab.name === '2') {
        this.form.strategy_id = '';
        this.form.RosterId = '';
      }
      this.form.app_id = '';
      this.form.verifyUser = '';
      this.managerList = [];
    },
    rosterFormChange(id) {
      if (/^\d+$/.test(id)) {
        this.selectedRoster = this.rosterList.find((e) => {
          return e.RosterId == id;
        }).RosterName;
      } else {
        const selectedAppObj = this.passAppList.find((e) => {
          return e.app_id == id;
        });
        this.selectedApp = selectedAppObj.app_name;
      }
      this.getManagerList();
      if (this.selectedTab === '1') {
        if (this.form.RosterId && this.form.app_id) {
          // 在名单页，且选了表单的情况下，查询人数
          GetSendUserNum({
            RosterId: this.form.RosterId,
            AppId: this.form.app_id,
          })
            .then(({ Total, Success, Fail }) => {
              this.rosterUserCount = { Total, Success, Fail };
            })
            .catch((e) => {
              this.$message.error(e);
            });
        }
      }
    },
    fanRosterFormChange(id) {
      if (/^\d+$/.test(id)) {
        this.selectedFanRoster = this.fanRosterList.find((e) => {
          return e.RosterId == id;
        }).RosterName;
      } else {
        const selectedAppObj = this.passAppList.find((e) => {
          return e.app_id == id;
        });
        this.selectedApp = selectedAppObj.app_name;
      }
      this.getManagerList();
      if (this.selectedTab === '2') {
        if (this.form.fanRosterId && this.form.app_id) {
          // 在粉丝名单页，且选了表单的情况下，查询人数
          GetSendUserNum({
            RosterId: this.form.fanRosterId,
            AppId: this.form.app_id,
          })
            .then(({ Total, Success, Fail }) => {
              this.fanRosterCount = { Total, Success, Fail };
            })
            .catch((e) => {
              this.$message.error(e);
            });
        }
      }
    },
    strategyChange(id) {
      this.selectedStrategy = this.strategyList.find((e) => {
        return e.id == id;
      }).strategy_name;
      let pubulcList = [];
      this.form.app_id = null;
      if (id === 0) {
        pubulcList = this.passAppList;
        this.form.strategy_name = '全部用户';
      } else {
        this.strategyList.forEach((item) => {
          if (item.id === id) {
            this.form.strategy_name = item.strategy_name;
            item.app_relation_list.forEach((app) => {
              const flag = this.passAppList.find((f) => {
                if (f.app_id === app.app_id) {
                  return true;
                }
              });
              if (flag) {
                pubulcList.push(app);
              }
            });
          }
        });
      }
      this.pubulcList = pubulcList;
    },
    changeDatePicker(e) {
      if (e === this.nowDay) {
        this.setPickerOptions();
      }
    },
    setPickerOptions() {
      this.form.startTime = '';
      this.defaultValue = new Date().getTime() + 360000;
      let future = new Date(this.defaultValue);
      future = formatTime(future, 'hh:ii:ss');
      this.pickerOptionsMinute = {
        selectableRange: `${future} - 23:59:59`,
      };
    },
    // 设置列表 外部调用
    setArticleSortList(list) {
      this.articleList = list;
    },
    // 改变列表位置
    changeArticlePosition(index, type) {
      // 将目标位置元素替换成现在的，将现在位置元素替换为截取的元素，
      const step = type != 1 ? 1 : -1;
      this.articleList[index] = this.articleList.splice(
        index + step,
        1,
        this.articleList[index],
      )[0];
      this.activeIndex = this.activeIndex + step;
    },
    // 检查时间
    checkTimeIsLegal() {
      return new Promise((resolve, reject) => {
        if (this.form.is_set_time) {
          // 定时群发时间必须为五分钟以后  定时群发时间必须为一周之内
          const sendTime = new Date(`${this.form.date} ${this.form.startTime}`).getTime();
          if (sendTime < new Date().getTime() + 1000 * 60 * 5) {
            this.$message.error('定时群发时间必须为五分钟以后');
            reject();
          }
          resolve({ status: 1, sendTime });
        }
        resolve({ status: 2 });
      });
    },
    // 是否传送 mediaId
    // 如果有这个Id 核对一下参数 相同就传过去
    isSendMediaId(artIds) {
      return new Promise((resolve) => {
        if (this.previewFrom.media_id) {
          const previewArtIds = [...this.previewFrom.art_ids];
          if (this.form.app_id === this.previewFrom.app_id) {
            if (artIds.length !== previewArtIds.length) {
              resolve();
            }
            for (let i = 0; i < artIds.length; i++) {
              const index = previewArtIds.indexOf(artIds[i]);
              if (index != -1) {
                previewArtIds.splice(index, 1);
              } else {
                resolve();
                break;
              }
            }
            if (previewArtIds.length == 0) {
              resolve({
                status: 'need',
              });
            }
          }
        } else {
          resolve();
        }
      });
    },
    checkForm() {
      return new Promise((resolve, reject) => {
        if (this.selectedTab === '0') {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        } else if (this.selectedTab === '1') {
          this.$refs.ruleForm2.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        } else if (this.selectedTab === '2') {
          this.$refs.ruleForm3.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }
      });
    },
    handleTime(time) {
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '.');
      }
      return '-';
    },
    generateMsg(RepeatedInfos = []) {
      // console.log(RepeatedInfos);
      // const artIds = RepeatedInfos.map((item) => {
      //   return item.ArtId;
      // });
      // console.log('artIds', artIds);
      // console.log('articleList', this.articleList);
      let checkMsg = '';
      const nameMap = {
        0: `"${this.selectedStrategy}"策略`,
        1: `"${this.selectedRoster}"名单`,
        2: `"${this.selectedFanRoster}"指定人员`,
      };
      RepeatedInfos.forEach((item) => {
        const temparticle = this.articleList.find((article) => {
          return article.art_id === item.ArtId;
        });
        const time = this.handleTime(item.LastPushTime);
        const message = `<p>文章"${temparticle.title}"在${time}按照${
          nameMap[this.selectedTab]
        }已经发布到${this.selectedApp};</p>`;
        checkMsg += message;
      });
      checkMsg += '<p>是否继续发布？</p>';
      return checkMsg;
    },
    async checkPublish(params) {
      const res = await CheckArticlePublish(params);
      console.log(res);
      const { Result = 0, RepeatedInfos = [] } = res;
      this.publishChecked = true;
      if (Result === 1) {
        // const artIds = RepeatedInfos.map((item) => {
        //   return item.ArtId;
        // });
        // const message = artIds.join(',');
        const msg = this.generateMsg(RepeatedInfos);
        console.log('msg', msg);
        this.$confirm(msg, {
          dangerouslyUseHTMLString: true,
          customClass: 'check-publish-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.submitForm();
          })
          .catch(() => {
            this.bottonLoading = false;
          });
        return false;
      }
      return true;
      // console.log(err);
      // this.publishChecked = true;
      // return true;
    },
    submitForm() {
      this.checkForm().then(() => {
        // if (valid) {
        const form = {
          send_time: 0, // 默认传 0 必传字段
          art_ids: this.articleList.map((e) => e.art_id),
        };
        // 检查文章是否有投票
        // 检查时间是否符合
        this.checkTimeIsLegal()
          .then((tiemRes) => {
            // 检查是否要穿media_id
            this.isSendMediaId(form.art_ids).then(async (sendMediaRes) => {
              if (sendMediaRes && sendMediaRes.status === 'need') {
                form.media_id = this.previewFrom.media_id;
              }
              if (tiemRes.status === 1) {
                form.send_time = tiemRes.sendTime / 1000;
              }
              if (this.selectedTab === '1') {
                form.roster_id = this.form.RosterId;
              }
              if (this.selectedTab === '2') {
                form.roster_id = this.form.fanRosterId;
              }
              // 用户来源，0=策略，1=名单, 2=粉丝名单
              form.user_source = Number.parseInt(this.selectedTab, 10);
              if (form.user_source === 2) {
                form.user_source = 1; // 粉丝名单也传1
              }
              form.app_id = this.form.app_id;
              form.strategy_id = this.form.strategy_id;
              form.strategy_name = this.form.strategy_name;
              form.is_set_time = this.form.is_set_time;
              let checkRosterId;
              let checkStrategyId;
              if (this.selectedTab === '0') {
                form.count = this.strategyUserCount;
                checkRosterId = -1;
                checkStrategyId = this.form.strategy_id;
              } else if (this.selectedTab === '1') {
                form.count = this.rosterUserCount.Success;
                checkRosterId = this.form.RosterId;
                checkStrategyId = -1;
              } else if (this.selectedTab === '2') {
                form.count = this.fanRosterCount.Success;
                checkRosterId = this.form.fanRosterId;
                checkStrategyId = -1;
              }
              form.VerifyUser = this.form.verifyUser;
              this.bottonLoading = true;
              const checkParam = {
                ArtIds: this.articleList.map((e) => e.art_id),
                PushTarget: {
                  WechatTarget: {
                    AppId: this.form.app_id,
                    StrategyId: checkStrategyId,
                    RosterId: checkRosterId,
                  },
                },
              };
              if (!this.publishChecked) {
                const checkres = await this.checkPublish(checkParam);
                console.log('checkres', checkres);
                if (!checkres) {
                  return;
                }
              }
              publishArticleWeChatPageApi(form)
                .then(() => {
                  this.bottonLoading = false;
                  this.$emit('on-success');
                  this.$message.success('发布成功!');
                })
                .catch((e) => {
                  this.bottonLoading = false;
                  this.$confirm(e.message, '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    showCancelButton: false,
                  });
                });
            });
          })
          .catch(() => {
            this.bottonLoading = false;
          });
        // }
      });
    },
    // 向上移动
    goUp() {
      if (this.articleList.length === 1) {
        this.$message.warning('只有一篇文章了,无法操作.');
        return;
      }
      if (this.activeIndex === null) {
        this.$message({
          message: '请选择需要调整的文章',
          type: 'warning',
        });
        return;
      }
      if (this.activeIndex === 0) {
        this.$message({
          message: '已经到顶啦',
          type: 'warning',
        });
        return;
      }
      if (this.activeIndex === 1) {
        window.scrollTo(0, 0);
      }
      this.changeArticlePosition(this.activeIndex, 1);
    },
    // 向下移动
    goDown() {
      if (this.articleList.length === 1) {
        this.$message.warning('只有一篇文章了,无法操作.');
        return;
      }
      if (this.activeIndex === null) {
        this.$message({
          message: '请选择需要调整的文章',
          type: 'warning',
        });
        return;
      }
      if (this.activeIndex === this.articleList.length - 1) {
        this.$message({
          message: '已经到底啦',
          type: 'warning',
        });
        return;
      }
      this.changeArticlePosition(this.activeIndex, 0);
    },
    // 移除文章
    deleteArticle() {
      if (this.articleList.length === 1) {
        this.$message.warning('只剩下一篇文章了,无法删除.');
        return;
      }
      if (this.activeIndex === null) {
        this.$message({
          message: '请选择需要移除的文章',
          type: 'warning',
        });
        return;
      }
      const delItem = this.articleList.splice(this.activeIndex, 1);
      this.$emit('changeList', delItem[0]);
      this.activeIndex = null;
    },
    // 点击选择需要排序的item,设置高亮
    activeArticle(index) {
      this.activeIndex = index;
    },
    // 关闭弹窗
    closeDialog() {
      this.activeIndex = null;
      this.openPreviewStatus = false;
      this.form = {
        app_id: '',
        strategy_id: '',
        is_set_time: false,
        date: '',
        startTime: '',
      };
      this.$emit('closeDialog', false);
    },

    // 打开预览
    openPreview() {
      if (!this.form.app_id) {
        this.$message({
          message: '请选择公众号后预览',
          type: 'warning',
        });
        return;
      }
      this.openPreviewStatus = true;
    },
    // 关闭预览弹窗
    closePreview() {
      this.openPreviewStatus = false;
    },
    // maybe discard
    userCountByAppIdAndStrategyId(form) {
      userCountByAppIdAndStrategyIdApi(form)
        .then((res) => {
          this.messageTimes = res.messageTimes;
          this.strategySendUserCount = res.strategySendUserCount;
          this.strategyUserCount = res.strategyUserCount;
          this.bottonLoading = false;
        })
        .catch((e) => {
          this.$message(e.message);
          this.bottonLoading = false;
        });
    },
    remoteSearchRoster(name) {
      GetRosterList({
        PageIndex: 1,
        PageSize: 20,
        RosterName: name,
        // MinNum: 2,
        Type: 0,
      })
        .then((res) => {
          this.rosterList = res.Rosters;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    remoteSearchFanRoster(name) {
      console.log(name);
      GetRosterList({
        PageIndex: 1,
        PageSize: 20,
        RosterName: name,
        // MinNum: 2,
        Type: 1,
      })
        .then((res) => {
          this.fanRosterList = res.Rosters;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    remoteSearchStrategy(strategyName) {
      // status: 1,
      const form = {
        strategy_name: strategyName,
        page_index: 1,
        page_size: 20,
      };
      getStrategyList(form)
        .then((res) => {
          const strategyList = [
            {
              id: 0,
              strategy_name: '全部用户',
            },
          ];
          this.strategyList = strategyList.concat(res.list);
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    selectFocus(refName, arrName) {
      if (this[arrName].length === 0) {
        this.$refs[refName].remoteMethod();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'index.scss';
</style>
<!--下面这个不要加scoped，会导致样式失效-->
<style lang="scss">
.check-publish-message-box {
  .el-message-box__content {
    max-height: 500px;
    overflow-y: scroll;
  }
}
</style>
